<style lang="scss" scoped>
    @import "../../../assets/sass/_mixins.scss";

    .ball {
        position: relative;
        width: 220px;
        height: 220px;
        padding: 10px;
        margin: 50px auto;
        top: -50px;
        background-color: #fff;
        border: 1px solid rgba(54, 64, 74, 0.1);
        border-radius: 50%;
        transform-origin: center center;
        @include animation(bounce 1.5s forwards);

        .source_animate {
            content: "";
            position: absolute;
            top: 15px;
            right: 15px;
            width: 12px;
            height: 12px;
            border-radius: 100%;
            opacity: 0;
            background-color: rgba(95, 190, 170, 0.6);
            @include transform(scale(0));
            @include transition(all, 2s, forwards);
        }

        .user-photo-mask,
        .lines {
            opacity: 0;
            @include transition(all, 0.3s, ease-out);
        }

        &.scale {
            @include animation(expand .5s 1 forwards);

            .source_animate {
                opacity: 0;
                @include transform(scale(1));
            }

            .user-photo {
                position: relative;
                max-width: 120px;
                height: 120px;
                margin: 41px auto 20px;
                background-color: #eee;
                border-radius: 50%;
                opacity: 0;
                overflow: hidden;
                @include transform(scale(0.5));
                -webkit-transform-origin: center center;
                -moz-transform-origin: center center;
                -ms-transform-origin: center center;
                -o-transform-origin: center center;
                transform-origin: center center;

                &.user-photo-animate {
                    @include animation(scaleUser .3s 1 forwards);
                }
            }

            .user-photo-mask {
                position: absolute;
                top: 100px;
                left: 50%;
                width: 140px;
                opacity: 0;
                overflow: hidden;
                @include transform(translate(-50%,0px));

                > img {
                    position: relative;
                }

                .avatar_animate {
                    position: relative;
                    @include animation(avatar_move 10s linear infinite);

                    img {
                        width: 140px;
                        border-radius: 100%;
                    }

                    &:before,
                    &:after {
                        content: "";
                        position: absolute;
                        bottom: 43px;
                        width: 6px;
                        height: 9px;
                        background-color: #b8a192;
                        border-radius: 100%;
                        z-index: 1;
                        @include animation(glass 7s linear infinite);
                    }

                    &:before {
                        left: 54px;
                    }

                    &:after {
                        left: 81px;
                    }
                }
            }

            .user-img {
                @include animation(moveUser 0.3s 1 forwards);
            }

            .user-name {
                width: 100%;
                text-align: center;
                opacity: 0;

                > span {
                    display: inline-block;
                    width: 100px;
                    height: 6px;
                    margin: 0px;
                    border-radius: 5px;
                    background-color: rgba(93, 156, 236, 0.6);
                }
            }

            ul.lines {
                position: relative;
                max-width: 150px;
                margin: 0 auto;
                opacity: 1;
                padding: 0px;

                > li {
                    height: 6px;
                    list-style: none;
                    display: inline-block;
                    margin-top: 16px;
                    opacity: 0;
                    border-radius: 5px;
                    background-color: #eee;

                    &:nth-child(1) {
                        width: 100%;
                    }

                    &:nth-child(2) {
                        width: 90%;
                    }

                    &:nth-child(3) {
                        width: 80%;
                    }
                }
            }

            .boxes_animate {
                position: relative;
                width: 1.4em;
                height: 1.4em;
                margin: 0 22px;
                opacity: 0;
                float: left;
                border-radius: 3px;
                background-color: #eeeeee;
            }

            .animated {
                -webkit-animation-duration: 1s;
                -moz-animation-duration: 1s;
                animation-duration: 1s;
                -webkit-animation-fill-mode: both;
                -moz-animation-fill-mode: both;
                animation-fill-mode: both;
            }
        }
    }

    .fadeInUp {
        -webkit-animation-name: fadeInUp;
        -moz-animation-name: fadeInUp;
        animation-name: fadeInUp;
    }

    // Keyframes
    @include keyframes(expand) {
        0% {
            top: 0px;
            @include transform(rotate(0deg));
        }
        100% {
            height: 380px;
            top: 0px;
            border-radius: 5px;
            @include transform(rotate(360deg));
            @include transition(all, .2s, forwards);
        }
    }

    @include keyframes(bounce) {
        0% {
            top: -50px;
            height: 220px;
            -webkit-animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
        }
        25% {
            top: 200px;
            height:155px;
            -webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
        }
        45% {
            top: -50px;
            width: 220px;
            height: 220px;
            -webkit-animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
        }
        80% {
            top: 200px;
            height: 155px;
            -webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
        }
        85% {
            top: -50px;
            width: 220px;
            height: 220px;
            -webkit-animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
        }
    }

    @include keyframes(scaleUser) {
        0% {
            opacity:0;
            @include transform(scale(0.5));
        }
        50% {
            opacity:1;
            @include transform(scale(1.2));
        }
        100% {
            opacity:1;
            @include transform(scale(1));
        }
    }

    @include keyframes(moveUser) {
        0%{
            opacity: 0;
            top: 100px;
        }
        100% {
            opacity: 1;
            top: 30px;
        }
    }

    @include keyframes(fadeInUp) {
        0% {
            opacity:0;
            @include transform(translate3d(0, 100%, 0));
        }
        100% {
            opacity:1;
            @include transform(none);
        }
    }

    @include keyframes(glass) {
        19%,
        21%,
        39%,
        41% {
            height: 9px;
            width: 6px;
        }
        20%,
        40% {
            height: 2px;
            width: 8px;
        }
    }

    @include keyframes(avatar_move) {
        18%,
        22%,
        26%,
        28% {
            @include transform(rotateZ(0));
        }
        20% {
            @include transform(rotateZ(8deg));
        }
        24% {
            @include transform(rotateZ(-8deg));
        }
    }
</style>

<template>
    <master-layout>
        <form @submit.prevent="store" novalidate>

            <!-- First Lead -->
            <div class="row">
                <div class="col-xs-12 col-sm-7 col-md-6">
                    <div class="card-box m-0">
                        <h4 class="t_uppercase t_center m-0"><b>{{ $t('add_your_first_deal') }}</b></h4>
                        <hr>

                        <!-- Lead -->
                        <h5 class="m-t-0"><i class="fa-fw ti-user"></i> {{ $t('lead') }}</h5>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.first_name']}">
                                <label>{{ $t('first_name') }}</label>
                                <input type="text" v-model="lead.first_name" class="form-control" id="first_deal" autofocus>
                                <span class="error" v-if="errors['lead.first_name']">{{ errors['lead.first_name'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.last_name']}">
                                <label>{{ $t('last_name') }}</label>
                                <input type="text" v-model="lead.last_name" class="form-control">
                                <span class="error" v-if="errors['lead.last_name']">{{ errors['lead.last_name'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12" :class="{'has-error': errors['lead.email']}">
                                <label class="input-group">
                                    <span class="input-group-addon"  v-pml-tooltip="$t('email')">
                                        <i class="fa-fw fa fa-envelope"></i>
                                    </span>
                                    <input type="email" v-model="lead.email" :placeholder="$t('email')" class="form-control p-r-25">
                                </label>
                                <span class="error" v-if="errors['lead.email']">{{ errors['lead.email'][0] }}</span>
                            </div>
                        </div>

                        <hr>

                        <!-- Infos -->
                        <h5 class="m-t-0"><i class="fa-fw fa fa-info-circle"></i> {{ $t('info') }}</h5>
                        <div class="row">
                            <div class="col-xs-12 m_bottom_15" :class="{'has-error': errors['deal.source_id']}">
                                <label>{{ $t('source') }}</label>
                                <pml-select v-model="deal.source_id" :options="sources()"></pml-select>
                                <span class="error" v-if="errors['deal.source_id']">{{ errors['deal.source_id'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12" :class="{'has-error': errors['deal.comments']}">
                                <label>{{ $t('comments') }} <small class="text-muted">({{ $t('deal') }})</small></label>
                                <textarea v-model="deal.comments" class="form-control"></textarea>
                                <span class="error" v-if="errors['deal.comments']">{{ errors['deal.comments'][0] }}</span>
                            </div>
                        </div>

                        <hr>

                        <!-- Add Lead / Deal -->
                        <div class="row">
                            <div class="col-xs-12 t_center">
                                <button type="submit" class="btn btn_green" v-pml-block="isSaving">{{ $t('save_and_go_to_deal') }}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Animation -->
                <div class="col-xs-12 col-sm-5 col-md-6 text-center">

                    <!-- Avatar -->
                    <label for="first_deal" class="ball">
                        <div class="source_animate animated"></div>
                        <div class="user-photo"></div>
                        <div class="user-photo-mask">
                            <div class="avatar_animate">
                                <img src="/static/images/avatar_animate.png" alt="Lead Pump">
                            </div>
                        </div>
                        <div class="user-name animated">
                            <span></span>
                        </div>
                        <ul class="lines text-left">
                            <li class="animated"></li>
                            <li class="animated"></li>
                            <li class="animated"></li>
                        </ul>
                        <div class="clearfix m-t-30 m-b-30">
                            <div class="boxes_animate animated"></div>
                            <div class="boxes_animate animated"></div>
                            <div class="boxes_animate animated"></div>
                        </div>
                    </label>

                </div>
            </div>
        </form>
    </master-layout>
</template>

<script>
    import jQuery from 'jquery'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { createWithLead } from 'services/deals'
    import { mapGetters, mapActions } from 'vuex'
    import {isNull} from 'lodash'
    import Tour from 'utils/helpers/tour'
    import bus from 'utils/events/bus'

    export default {
        name: 'FirstDeal',
        data () {
            return {
                lead: {},
                deal: {
                    source_id: null
                },
                errors: [],
                isSaving: false
            }
        },
        computed: {
            ...mapGetters({
                'member': 'getMember',
                'sources': 'getActiveSources',
                'showTour': 'getShowTour'
            })
        },
        created () {
            bus.$on('startTour', this.startTour)
        },
        mounted () {
            this.deal.member_id = this.member.id
            this.startTour()

            setTimeout(function () {
                jQuery('.ball').addClass('scale')
            }, 1500)
            setTimeout(function () {
                jQuery('.user-photo').addClass('user-photo-animate')
            }, 2200)
            setTimeout(function () {
                jQuery('.user-photo-mask').addClass('user-img')
            }, 2400)
            setTimeout(function () {
                jQuery('.user-name').addClass('fadeInUp')
            }, 2500)
            setTimeout(function () {
                var children = jQuery('.lines > li, .boxes_animate, .source_animate')
                var index = 0
                function addClassNextChild () {
                    if (index === children.length) return
                    children.eq(index++).addClass('fadeInUp')
                    window.setTimeout(addClassNextChild, 200)
                }
                addClassNextChild()
            }, 2600)
        },
        methods: {
            ...mapActions(['setShowTour']),
            store () {
                this.isSaving = true

                createWithLead({ deal: this.deal, lead: this.lead })
                    .then(response => {
                        Notify.success(trans('_notifications.success'))
                        this.$router.push({ name: 'deals.show', params: { id: response.data.id } })
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            },
            startTour () {
                if ((!isNull(window.localStorage.getItem('pml_tour')) || this.showTour) && window.innerWidth > 767)
                    setTimeout(() => { Tour.start(this.member.is_admin) }, 1000)

                if (this.showTour)
                    this.setShowTour(false)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/dashboard/components/FirstDeal.vue